import React, {Component} from "react";
import {
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    UncontrolledTooltip
} from "reactstrap";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import emailMask from "text-mask-addons/dist/emailMask";
import MaskedInput from "react-text-mask";
import {validateField} from "../../common/validation";

class SmmmUserModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            information: {
                name: "",
                surname: "",
                software: "",
                telephone: "",
                email: ""
            },
            disableSaveButton: false,
            error: {},
            isMobile : window.innerWidth > 991 ? false : true
        };

        this.onChange = this.onChange.bind(this);
        this.saveClicked = this.saveClicked.bind(this);
        this.validate = this.validate.bind(this);
        this.getCustomerProperties = this.getCustomerProperties.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onChangeCheck = this.onChangeCheck.bind(this);
        this.fetchCompleteUser = this.fetchCompleteUser.bind(this);
    }

    componentDidMount() {
        this.getCustomerProperties();
    }

    onChange(name, value) {
        if(name === "email") value = value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
        let information = deepCopyObject(this.state.information);
        information[name] = value;
        this.setState({information});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result;
        let error = this.state.error;

        if (rule === "phone" && value.includes("_")) {
            result = validateField(rule, undefined, value);
        } else
            result = validateField(rule, boundary, value);
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    getCustomerProperties() {
        const self = this;
        let params = {
            url: `/smmmUserInformation/getCustomerProperties`,
            method: "post",
            data: {
                customerId: (self.props.customer && self.props.customer.recordId) || (self.props.currentUser && self.props.currentUser.customerId)
            }
        };
        request(params)
            .then(function (response) {
                let customerProperties = response.data;
                if (customerProperties) {
                    self.setState({
                        information: {
                            recordId: customerProperties.recordId,
                            customerId: customerProperties.customerId,
                            userId: customerProperties.userId,
                            name: customerProperties.name,
                            surname: customerProperties.surname,
                            software: customerProperties.software,
                            telephone: customerProperties.telephone,
                            email: customerProperties.email
                        }
                    });
                } else {
                    self.setState({
                        information: {
                            name: "",
                            surname: "",
                            software: "",
                            telephone: "",
                            email: ""
                        }
                    });
                }
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    saveClicked() {
        let self = this;
        self.setState({disableSaveButton: true});
        let error = self.validate();
        if (!error.valid) {
            showAxiosError({message: error.message});
            self.setState({disableSaveButton: false});
        } else {
            let information = deepCopyObject(this.state.information);
            if (information["recordId"] === null || information["recordId"] === undefined) {
                information["recordId"] = null;
                information["userId"] = null;
            }
            let params = {
                url: `/smmmUserInformation/save`,
                method: 'post',
                data: information
            };
            request(params)
                .then(response => {
                    self.props.toggle();
                }).catch(error => {
                self.setState({disableSaveButton: false});
                showAxiosError(error);
            });
        }
    }

    validate() {
        let information = deepCopyObject(this.state.information);
        let error = {valid: true, message: ""};
        let value;
        for (value in information) {
            if (information[value].toString() === "undefined" || information[value].toString() === "null" || information[value].toString() === "") {
                error.valid = false;
                error.message = "Devam etmek için lütfen zorunlu alanları doldurunuz.";
                break;
            }
            if (value === "email") {
                let emailError = validateField("email", "1,255", information[value]);
                if (!emailError.valid) {
                    error.valid = false;
                    error.message += emailError.message;
                }
            }

            if (value === "telephone") {
                let phoneError;
                if (information[value].includes("_")) {
                    phoneError = validateField("phone", undefined, information[value]);
                } else
                    phoneError = validateField("phone", "13,13", information[value]);

                if (!phoneError.valid) {
                    error.valid = false;
                    error.message += phoneError.message;
                }
            }
        }
        return error;
    }

    fetchCompleteUser() {
        const self = this;
        let params = {
            url: `/user/fetchCompleteUserForSmmInfo/${this.props.currentUser.id}`,
            method: 'post'
        };
        request(params)
            .then(function (response) {
                let completeUser= response.data;
                if(!completeUser.sorumluCepTel.includes("+90"))
                    completeUser.sorumluCepTel = "+90" + completeUser.sorumluCepTel
                if(completeUser) {
                    self.setState({
                        information: {
                            name: completeUser.name,
                            surname: completeUser.surname,
                            email: completeUser.email,
                            telephone: completeUser.sorumluCepTel,
                            software:""
                        }
                    });
                } else{
                    self.setState({
                        information: {
                            name: "",
                            surname: "",
                            software: "",
                            telephone: "+90",
                            email: ""
                        }
                    });
                }
            })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    onChangeCheck() {
            this.fetchCompleteUser()
    }

    render() {
        const {isMobile} = this.state;
        return <Modal isOpen={this.props.isOpen} size="lg">
            <ModalHeader
                // toggle={() => this.props.toggle()}
                className="justify-content-center">
                Kullanıcı Bilgileri
            </ModalHeader>
            <ModalBody>
                <div>
                    <Form>
                        <FormGroup row style={{textAlign: 'center'}}>
                            <Label sm={12} for="formattedName" style={{fontWeight: 'bold', fontSize: !isMobile ? '16px' : '11px'}}>E-Fatura
                                muhasebe entegrasyon sürecine destek olabilmemiz için lütfen aşağıdaki forma muhasebeci
                                bilgilerinizi doldurunuz.</Label>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} style={{fontSize: "11px", fontWeight: "bold"}} sfor="check">KENDİM TUTUYORUM:</Label>
                            <Col sm={8}>
                                <input type="checkbox"
                                       id="checkbox"
                                       onChange={(e) => this.onChangeCheck(e)}
                                       />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="name">Muhasebeci Adı: *</Label>
                            <Col sm={8}>
                                <Input type="text" name="name" value={this.state.information.name}
                                       onChange={(e) => this.onChange("name", e.target.value)}
                                       />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="surname">Muhasebeci Soyadı: *</Label>
                            <Col sm={8}>
                                <Input type="text" name="surname" value={this.state.information.surname}
                                       onChange={(e) => this.onChange("surname", e.target.value)}
                                       />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="software">Kullanılan Muhasebe Yazılımı: *</Label>
                            <Col sm={8}>
                                <Input type="text" name="software" value={this.state.information.software}
                                       onChange={(e) => this.onChange("software", e.target.value)}/>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="telephone">Telefon Numarası: *</Label>
                            <Col className={"form-group" + this.validateClass('tTelephone')} sm={8}>
                                <MaskedInput className="form-control"
                                             mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                             placeholder="+90__________"
                                             type="text"
                                             id="tTelephone"
                                             ref="tTelephone"
                                             inputProps={{vdata: "phone", vlength: '13,13'}}
                                             guide={true}
                                             name="telephone"
                                             onBlur={() => this.validateField({
                                                 target: {
                                                     id: "tTelephone",
                                                     dataset: {vdata: "phone", vlength: '13,13'},
                                                     value: this.state.information.telephone
                                                 }
                                             })}
                                             value={this.state.information.telephone}
                                             onChange={(e) => this.onChange("telephone", e.target.value)}/>
                                {this.validateMessage('tTelephone') !== "" &&
                                <UncontrolledTooltip placement="right" target="tTelephone" delay={0}>
                                    {this.validateMessage("tTelephone")}
                                </UncontrolledTooltip>}
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="email">E-Posta: *</Label>
                            <Col className={"form-group" + this.validateClass('tEmail')} sm={8}>
                                <MaskedInput className="form-control"
                                             placeholder="_________@______.___"
                                             mask={emailMask}
                                             type="text"
                                             name="email"
                                             id="tEmail"
                                             inputProps={{vdata: "email", vlength: '1,255'}}
                                             ref="tEmail"
                                             value={this.state.information.email}
                                             onBlur={() => this.validateField({
                                                 target: {
                                                     id: "tEmail",
                                                     dataset: {vdata: "email", vlength: '1,255'},
                                                     value: this.state.information.email
                                                 }
                                             })}
                                             onChange={(e) => this.onChange("email", e.target.value)}
                                             />
                                {this.validateMessage('tEmail') !== "" &&
                                <UncontrolledTooltip placement="right" target="tEmail" delay={0}>
                                    {this.validateMessage("tEmail")}
                                </UncontrolledTooltip>}
                            </Col>
                        </FormGroup>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button style={{paddingLeft: '16px', width: '100px'}} color="primary" onClick={this.saveClicked}>
                    Kaydet
                </Button>
            </ModalFooter>
            {this.props.isOpen}
        </Modal>
    }
}

export default SmmmUserModal;